import React from 'react';
import { observer } from 'mobx-react';

import { Modal } from 'apps/modals/views/modal';
import { ModalTitle } from 'legacyComponents/styled/lib';
import { Form } from 'libs/forms';
import { Trans } from 'react-i18next';

import { PostFormAppManager } from 'apps/aggregator/postForm/appManager';

@observer
export class PostForm extends Modal {
  UNSAFE_componentWillMount() {
    this.appManager = new PostFormAppManager(null, {});
  }

  render() {
    const { postFormApp } = this.appManager;
    const { form } = postFormApp;
    const {
      conf: { formTitle },
    } = form;
    return (
      <>
        <ModalTitle level={2}>
          <Trans>{formTitle}</Trans>
        </ModalTitle>
        <Form
          formStore={form}
          formTitle=''
          buttonHandler={postFormApp.Submit}
          noBorder
          padding='0'
        />
      </>
    );
  }
}
